define('Search/SearchFilters',["Search/Search", "instantsearch", "hierarchicalrefinmentlist", "jquery", "resourcerefinementlist", "eventManager"],

    function (Search, instantsearch, hierarchicalRefinmentlist, $, resourceRefinementList, eventManager) {

        function SearchFilters(firstSearchFiltersId, algoliaApplicationId, algoliaApiKey, algoliaIndexName, contextLanguage, clearAllId, clearAllLabel, secondSearchFiltersId) {

            if (!Search.configured) {
                Search.defaultConfig(algoliaApplicationId, algoliaApiKey, algoliaIndexName, contextLanguage, clearAllId, clearAllLabel);
            }

            var hierarchicalRefinementListWidget = instantsearch.widgets.hierarchicalRefinmentList({
                container: '#' + firstSearchFiltersId,
                attributes: ["_industry_hierarchy.Industry", "_industry_hierarchy.SubIndustry"],
                sortBy: ['name:asc', 'count:desc'],
                operator: ">",
                cssClasses: {
                    list: "search-filters-list",
                    item: "search-filters-item",
                    secondLvlItem: "search-filters-second-lvl-item",
                    count: "search-filters-item-count",
                    name: "search-filters-item-name"
                }
            }, algoliaApplicationId, algoliaApiKey, algoliaIndexName, contextLanguage, "_language");

            Search.addWidget(hierarchicalRefinementListWidget);

            var resourceTypesFacetWidget = instantsearch.widgets.resourceRefinementList({
                container: '#' + secondSearchFiltersId,
                attribute: '_resource_type',
                sortBy: ['name:asc', 'count:desc'],
                operator: 'and',
                cssClasses: {
                    list: "search-filters-list",
                    item: "search-filters-item",
                    count: "search-filters-item-count",
                    name: "search-filters-item-name"
                }
            }, algoliaApplicationId, algoliaApiKey, algoliaIndexName, contextLanguage, "_language");

            Search.addWidget(resourceTypesFacetWidget);

            $('#' + clearAllId).on('click', function (e) {
                hierarchicalRefinementListWidget.clearAll();
                resourceTypesFacetWidget.clearAll();
                eventManager.trigger("SearchFiltersUpdated");
                return false;
            });
        }

        return function InitSearchFilters(args) {
            return new SearchFilters(
                args.FirstSearchFiltersId,
                args.AlgoliaApplicationId,
                args.AlgoliaApiKey,
                args.AlgoliaIndexName,
                args.ContextLanguage,
                args.ClearAllId,
                args.ClearAllLabel,
                args.SecondSearchFiltersId);
        };
    });
